import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

export default definePreset(Aura, {
  primitive: {
    green: {
      50: "#f4fcf7",
      100: "#caf1d8",
      200: "#a0e6ba",
      300: "#76db9b",
      400: "#4cd07d",
      500: "#22c55e",
      600: "#1da750",
      700: "#188a42",
      800: "#136c34",
      900: "#0e4f26",
      950: "#052e16",
    },
  },
  semantic: {
    primary: {
      50: "{emerald.50}",
      100: "{emerald.100}",
      200: "{emerald.200}",
      300: "{emerald.300}",
      400: "{emerald.400}",
      500: "{emerald.500}",
      600: "{emerald.600}",
      700: "{emerald.700}",
      800: "{emerald.800}",
      900: "{emerald.900}",
      950: "{emerald.950}",
    },
  },
  components: {
    toolbar: {
      root: {
        color: "#000",
      },
    },
    menu: {
      submenuLabel: {
        color: "#94a3b8",
      },
    },
  },
});
